import axios from "Services/api";
import { createAsyncThunk } from "@reduxjs/toolkit";


export const getOTP = createAsyncThunk("auth/getOTP", async (data, thunkAPI) => {
  try {
    const response = await axios.post(`/GetOTP`, data);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error || "Something went wrong");
  }
});